export const resolveSelectedVehicleId = (vehicleList, selectedVehicle) => {
    if (!selectedVehicle || !Array.isArray(vehicleList) || vehicleList.length === 0) {
        return null;
    }

    const { id, vin, licenseNumber, provinceCode, year, makeId, modelId, trimId, fleetUnitNumber } = selectedVehicle;

    // 1) Direct ID match
    if (id) {
        const byId = vehicleList.find((v) => v?._id === id);
        if (byId?._id) return byId._id;
    }

    const normalize = (val) => (val === undefined || val === null ? '' : String(val).toLowerCase().trim());

    // 2) VIN match
    if (vin) {
        const targetVin = normalize(vin);
        const byVin = vehicleList.find((v) => normalize(v.vin) === targetVin);
        if (byVin?._id) return byVin._id;
    }

    // 3) License plate + province match
    if (licenseNumber) {
        const targetPlate = normalize(licenseNumber);
        const targetProvince = normalize(provinceCode);
        const byPlate = vehicleList.find((v) => {
            const vPlate = normalize(v.licenseNumber || v.license);
            const vProvince = normalize(v.provinceCode || v.province?.code || v.province?.provinceCode);

            if (vPlate !== targetPlate) return false;
            if (targetProvince && vProvince && vProvince !== targetProvince) return false;
            return true;
        });
        if (byPlate?._id) return byPlate._id;
    }

    // 4) Composite match on year + make + model + trim + fleetUnitNumber
    const candidates = vehicleList.filter((v) => {
        const vYear = v.year || v.vehicleYear;
        const vMakeId = v.vehicleMake?._id || v.vehicleMakeId;
        const vModelId = v.vehicleModel?._id || v.vehicleModelId;
        const vTrimId = v.vehicleModelTrim?._id || v.vehicleModelTrimId;
        const vFleet = v.fleetUnitNumber;

        if (year && vYear && String(year) !== String(vYear)) return false;
        if (makeId && vMakeId && normalize(makeId) !== normalize(vMakeId)) return false;
        if (modelId && vModelId && normalize(modelId) !== normalize(vModelId)) return false;
        if (trimId && vTrimId && normalize(trimId) !== normalize(vTrimId)) return false;
        if (fleetUnitNumber && vFleet && normalize(fleetUnitNumber) !== normalize(vFleet)) return false;

        return true;
    });

    return candidates[0]?._id || null;
};
